export default {
    'required': 'Это поле необходимо заполнить',
    'onlyCyrSymbol': 'Поле не должно содержать латинские букв',
    'cyrWithDash': 'Поле не должно содержать латинские буквы',
    'seemsDigitInPhone': 'Проверьте корректность номера',
    'email': 'Неверный формат',
    'onlyLatSymbol': 'Поле должно содержать только латиницу',
    'diffBetweenWordsLessThan': 'Можно изменить не более {num} символов',
    'validCityName': 'Поле не должно содержать латинские буквы',
    'checkCodeword': 'Длина кодового слова должна быть от 6 до 30 символов. Поле не должно содержать латинские буквы и спецсимволы',
    'addressCommas': 'Неверный формат',
    'isAgreed': 'Подтвердите согласие',
    'minLength': 'Значение поля не должно быть короче {min}',
    'maxLength': 'Значение поля не должно быть длиннее {max}',
    'numeric': 'Неверный формат',
    'passportSerNum': 'Неверный формат',
    'passportNum': 'Неверный формат',
    'passportCode': 'Неверный формат',
    'noCity': 'В выбранном регионе услуги банка не доступны',
    'noOffice': 'В выбранном городе услуги банка не доступны',
    'ageMin': 'Минимальный возраст: {min}',
    'ageMax': 'Максимальный возраст: {max}',
    'ageRange': 'Возраст должен быть больше 18 лет',
    'ageMinInsurance': 'Минимальный возраст страхования: {min}',
    'ageMaxInsurance': 'Максимальный возраст страхования: {max}',
    'minDate': 'Дата должна быть не ранее {date}',
    'maxDate': 'Дата должна быть не позднее {date}',
    'citiesNotFound': 'В выбранном регионе услуги банка не доступны',
    'officesNotFound': 'В выбранном городе услуги банка не доступны',
    'limitLatSymbol': 'Поле может содержать до {limit} латинских букв',
    'noAvailableDays': 'В выбранном городе нет доступных интервалов доставки',
    'timesNotFound': 'На выбранную дату нет свободных временных слотов',
    'requiredAddress': 'Выберите адрес из выпадающего списка',
    'serviceError': 'Сервис находится на техническом обслуживании, вернитесь позже',
};
